// extracted by mini-css-extract-plugin
export var explainable = "_hg-0";